import { SelectProps } from '@mui/material/Select'

/** Shared group-label look for Select ListSubheader and Autocomplete groups. */
export const optionGroupLabelSx = {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.4,
    color: 'text.primary',
    bgcolor: 'transparent',
} as const

export const listSubheaderProps: SelectProps['MenuProps'] = {
    PaperProps: {
        sx: {
            '& .MuiMenuItem-root': {
                py: 0.5,
                px: 1.5,
                ml: 2,
            },
            '& .MuiListSubheader-root': {
                ...optionGroupLabelSx,
                py: 0.75,
            },
        },
    },
}
